/**
 * 管理後台字典（en）
 *
 * 只放後台用得到的詞。前台的字典不共用 —— 兩邊的詞彙不一樣，
 * 而且共用會讓前台的 bundle 扛著一堆管理用語。
 *
 * en 是唯一的真實來源：TranslationKey 由它推導，
 * 其他三本是 Dictionary（必須逐條齊全，缺一條就編譯不過）。
 */
const en = {
  "nav.overview": "Overview",
  "nav.members": "Members",
  "nav.identity": "ID review",
  "nav.jobs": "Jobs",
  "nav.contracts": "Contracts",
  "nav.audit": "Audit log",
  "nav.emails": "Email log",
  "nav.settingsEmail": "Email settings",
  "nav.settingsPayments": "Payment settings",
  "shell.title": "Admin",
  "shell.brand": "ColoureDev admin",
  /*
    金流設定的「測試連線」結果。

    伺服器回 key + params 而不是組好的句子 —— 管理台有十八種語言，
    而一個泰文介面的審核人員看不懂中文的診斷訊息，那個按鈕
    對他等於不存在。
  */
  "env.sandbox": "sandbox",
  "env.live": "live",

  "pay.test.authFailed":
    "Authentication failed. Check the keys match the environment — you are on {env}.",
  "pay.test.httpError": "PayPal replied {status}.",
  "pay.test.paypalOk": "Connected ({env}). The token is valid for {minutes} minutes.",
  "pay.test.paypalOkNoWebhook":
    "Connected ({env}), token valid for {minutes} minutes — but no Webhook ID is set, so payment notifications will fail signature checks.",

  "pay.test.missing": "Not configured yet: {fields}",
  "pay.test.ecpayMerchantId": "A merchant ID is usually 7–10 digits",
  "pay.test.ecpayHashKey": "HashKey should be 16 characters, this one is {len}",
  "pay.test.ecpayHashIv": "HashIV should be 16 characters, this one is {len}",
  "pay.test.ecpayOk":
    "The format is right ({env}). Whether the keys work, and whether the store has payment methods enabled, only shows up on the first real transaction.",

  "shell.logout": "Log out",
  "shell.language": "Interface language",
  "shell.securityWarn": "The IP allowlist is switched off",
  "shell.allowlistOpen": "IP allowlist is off",
  "shell.allowlistOpenBody": "— this admin panel is currently open to the whole internet.",
  "shell.yourIp": "Your IP: {ip}",
  "login.allowlisted": "Your IP passed the allowlist",
  "login.password": "Password",
  "login.next": "Continue",
  "login.lockoutNote": "Repeated failures temporarily lock the account.",
  "login.codeSentTo": "Code sent to {hint}",
  "login.code": "Six-digit code",
  "login.codeTtl": "Valid for ten minutes.",
  "login.codeHint": "No email? Most likely the account or password was mistyped — to avoid revealing whether an account exists, a wrong password lands you on this screen too. Go back and check.",
  "login.submit": "Log in",
  "login.backToPassword": "Re-enter email and password",
  "login.badCode": "That code isn't right, or this sign-in has timed out.",
  "login.tooMany": "Too many attempts. The account is temporarily locked.",
  "login.fail": "Login failed. Please try again shortly.",
  "login.network": "Connection failed. Please try again shortly.",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.required": "Required",
  "update.title": "The site has been updated",
  "update.reload": "Reload",
  "lang.label": "Language",
  "ov.markets": "Markets",
  "ov.openJobs": "Open projects",
  "ov.thisWeek": "New this week",
  "ov.totalBudget": "Total budget posted",
  "ov.latest": "Latest activity: {kind}",
  "ov.emailHealth": "Email health",
  "ov.emailFailed": "{n} messages failed to send — check the email log for the reason.",
  "ov.template": "Template",
  "ov.status": "Status",
  "ov.count": "Count",
  "emails.title": "Email log (last 100)",
  "emails.empty": "No messages have been sent yet.",
  "emails.sent": "Sent",
  "emails.failed": "Failed",
  "audit.title": "Audit log (last 100)",
  "audit.empty": "Nothing recorded yet.",
  "audit.when": "When",
  "audit.action": "Action",
  "audit.target": "Target",
  "mb.all": "All",
  "mb.trial": "Free period",
  "mb.active": "Paying member",
  "mb.paying": "Paying",
  "mb.exhausted": "Free period used up",
  "mb.expired": "Expired",
  "mb.none": "Not a specialist",
  "mb.unverified": "Email not verified",
  "mb.suspended": "Suspended",
  "mb.search": "Search by email, name or handle",
  "mb.total": "{n} members",
  "mb.none2": "No members match those filters.",
  "mb.roleBoth": "Both roles",
  "mb.roleClient": "Client",
  "mb.roleFreelancer": "Specialist",
  "mb.daysLeft": "{n} days left",
  "mb.suspendReason": "Reason for suspension: {reason}",
  "mb.manage": "Manage",
  "mb.membership": "Membership",
  "mb.grantNote": "The new expiry is added to the current expiry, not counted from today.",
  "mb.grantMonths": "+{n} months",
  "mb.revoke": "Revoke paid period",
  "mb.emailVerify": "Email verification",
  "mb.emailVerifyNote": "Only for \"the user can't receive our email but has been identified another way\".",
  "mb.markVerified": "Mark as verified by hand",
  "mb.suspend": "Suspend account",
  "mb.restore": "Restore account",
  "mb.suspendNote": "Takes effect immediately; existing sessions are invalidated too. Projects, proposals and reviews are all kept.",
  "mb.restoreNote": "Once restored, this person can log in again straight away.",
  "mb.suspendReasonPlaceholder": "Reason for suspension (required)",
  "mb.suspendAction": "Suspend this account",
  "jobs.all": "All",
  "jobs.open": "Open",
  "jobs.awarded": "Awarded",
  "jobs.completed": "Completed",
  "jobs.removed": "Taken down",
  "jobs.search": "Search by title or content",
  "jobs.clear": "Clear",
  "jobs.loading": "Searching…",
  "jobs.total": "{n} projects",
  "jobs.none": "No projects match those filters.",
  "jobs.proposals": "{n} proposals",
  "jobs.views": "{n} views",
  "jobs.removedReason": "Reason for takedown: {reason}",
  "jobs.collapse": "Collapse",
  "jobs.restore": "Restore",
  "jobs.takeDown": "Take down",
  "jobs.restoreNote": "Once restored, this project reappears in public search.",
  "jobs.takeDownNote": "A takedown isn't a deletion: proposals, conversations and contracts are all kept, and the client can still see it along with the reason. It just won't be found in public search or on its detail page.",
  "jobs.reasonPlaceholder": "Reason for takedown (required)",
  "jobs.restoreAction": "Restore this project",
  "jobs.takeDownAction": "Take this project down",
  "ac.active": "Under way",
  "ac.completed": "Completed",
  "ac.cancelled": "Cancelled",
  "ac.disputed": "Disputed",
  "ac.total": "{n} contracts",
  "ac.empty": "No contracts yet",
  "ac.emptyBody": "Contracts appear once a client picks someone. This number is the most direct sign of whether the platform is actually working — proposals but no contracts means the last mile of matching is stuck.",
  "ac.milestones": "Milestones {done}/{total}",
  "ac.startedOn": "started {date}",
  "ac.endedOn": "ended {date}",
  "ac.readOnly": "This page is read-only. Admins can't change a contract — that's an agreement between two other people, and editing it would be deciding for one of them, which contradicts our own statement that we don't arbitrate. When something really does need action, it's suspending an account or taking a project down, and both live on other pages.",
  "sf.saved": "Saved. It takes effect within 60 seconds.",
  "sf.keepCurrent": "Keep the current setting",
  "sf.replaceHint": "Enter a new value to replace it",
  "sf.unset": "Not set",
  "sf.updatedAt": "Last updated {at}",
  "sf.fromDb": "Set here",
  "sf.fromEnv": "Environment variable",
  "sf.noMasterKey": "No encryption master key set",
  "sf.noMasterKeyBody": "Keys are encrypted before they go into the database, and the master key used to encrypt them has to be a Worker secret — storing it in the database too would mean nothing is really encrypted. Run this in your terminal:",
  "sf.rotateWarn": "Once the master key is replaced, existing settings can't be decrypted — you'll have to enter them again.",
  "nav.settingsAi": "AI provider",
  "sa.lede": "Optional. Bind a key and the away agent uses OpenRouter instead of our own models — you can then change model here without a deploy. Get a key at",
  "sa.ledeTail": "— leave both fields empty to keep using ours.",
  "sa.keyHint": "Once saved it can never be read back in the clear; you'll only see a masked preview. To change it, enter the whole thing again. Save an empty value to unbind.",
  "sa.modelHint": "Any OpenRouter model id, e.g. anthropic/claude-sonnet-4.5. Empty means {fallback}.",
  "sa.test": "Test the binding",
  "sa.testNote": "Asks the model to reply with one word. Sends nothing to anyone.",
  "sa.fallbackNote": "If OpenRouter fails — expired key, no credit, an outage — the agent falls back to our own models so clients still get an answer. Every fallback is written to the logs.",
  "sf.revoke": "Unbind",
  "sf.revokeConfirm": "Confirm unbind",
  "sf.revoked": "Unbound. The platform's own models are in use again.",
  "sa.cfFreeNote": "Workers AI has no free models — there is one shared allocation of 10,000 neurons a day across all of them, then $0.011 per 1,000. The number on each chip is neurons per million input tokens: lower stretches the free allocation further. Cheap is not the same as usable, though — the smallest models are the ones most likely to answer something the agent was told not to answer.",
  "sa.cfLede": "Optional. Pin one Workers AI model to try before the built-in list. Model ids are at",
  "sa.cfModelHint": "Added in front of the built-in list, not replacing it — a typo falls through to the next model instead of turning the feature off. Save empty to remove.",
  "se.lede": "The delivery service for every transactional email on the site. Create a key at",
  "se.ledeTail": "— Sending access is all the permission it needs.",
  "se.keyHint": "Once saved it can never be read back in the clear; you'll only see a masked preview. To change it, enter the whole thing again.",
  "se.fromHint": "The domain must already be verified in Resend, or the mail will bounce.",
  "se.test": "Test connection",
  "se.testNote": "The test only checks that the key works and what the domain's verification status is. It doesn't send anything.",
  "sp.env": "Environment",
  "sp.sandboxChip": "Test environment (sandbox)",
  "sp.liveChip": "Live · real money changes hands",
  "sp.envNote": "Test and live use two different sets of keys, and they can't be mixed. After switching environment, the keys below have to be swapped for the matching set.",
  "sp.sandbox": "Test environment (sandbox)",
  "sp.live": "Live environment",
  "sp.liveWarn": "Live creates real payment transactions. Run the full pay → callback → payout flow in the test environment before switching over.",
  "sp.paypalLede": "Everything outside Taiwan goes through here. Get the keys from",
  "sp.paypalLedeTail": "(mind the Sandbox and Live tabs).",
  "sp.paypalSecretHint": "The secret is shown in full only once, when you create the app; after that it can only be regenerated.",
  "sp.paypalWebhookHint": "Create a webhook in the dashboard pointing at https://colouredev.com/api/payments/webhook/paypal and subscribe to CHECKOUT.ORDER.APPROVED and PAYMENT.CAPTURE.COMPLETED. Without it, payment notifications fail signature verification.",
  "sp.testPaypal": "Test the PayPal connection",
  "sp.ecpayName": "ECPay",
  "sp.ecpayLede": "Serves the Taiwan market only. The keys come from ECPay's console, under System Development → Integration Settings. The test host is payment-stage.ecpay.com.tw; live is payment.ecpay.com.tw.",
  "sp.ecpay32": "Exactly 32 characters.",
  "sp.ecpay16": "Exactly 16 characters.",
  "sp.testEcpay": "Check the ECPay settings",
  "sp.ecpayTestNote": "ECPay offers no API for validating keys without creating an order, so all this can check is the format and whether encryption works. Whether the keys are actually right shows up on the first real transaction.",
  "sp.webhooks": "Callback URLs",
  "sp.webhooksNote": "Both payment providers need this URL configured in their console; otherwise successful-payment notifications never arrive and orders sit at pending forever:",
  // Was a hardcoded Chinese string thrown from the image loader. The
  // admin console runs in every language the site does.
  "idv.noImage": "The response did not contain an image.",
  "idv.empty": "Nothing waiting for review.",
  "idv.lede": "Images load only when you click, and every view is written to the audit log. Once a review is decided the images are deleted immediately — what we keep is the judgement, not the evidence behind it.",
  "idv.noDocType": "document type not given",
  "idv.showImages": "Show the images",
  "idv.approve": "Approve",
  "idv.approveLedeA": "Fill this in from what's on the document. The number is hashed into an identifier for \"this human being\" —",
  "idv.approveLedeEmphasis": "the original number is never written to the database",
  "idv.approveLedeB": "and the same document turning up a second time collides with the unique index.",
  "idv.docType": "Document type",
  "idv.choose": "Choose⋯",
  "idv.country": "Issuing country",
  "idv.docNumber": "Document number",
  "idv.optional": "(can be skipped)",
  "idv.noNumberWarn": "You can approve without a number, but if this person comes back later with a different email and a different phone, the system won't know it's the same person.",
  "idv.approveAction": "Approve this one",
  "idv.reject": "Reject",
  "idv.rejectLedeA": "Pick a reason. The user sees it",
  "idv.rejectLedeEmphasis": "in their own language",
  "idv.rejectLedeB": "— each one is written so they know what to do next.",
  "idv.chooseReason": "Choose a reason for rejection⋯",
  "idv.rejectAction": "Reject this one",
  "idv.front": "Front",
  "idv.back": "Back",
  "idv.docAlt": "{side} of the document",
  "idv.loadFailed": "Failed to load",
  "idv.doc.nationalId": "National ID card",
  "idv.doc.passport": "Passport",
  "idv.doc.driverLicense": "Driving licence",
  "idv.doc.residencePermit": "Residence permit",
  "idr.blurry": "The photo is too blurred to read. Please retake it somewhere well lit, with the whole document in frame.",
  "idr.cropped": "The edges of the document are cut off. Please retake it with all four corners fully in frame.",
  "idr.glare": "Glare or a shadow is covering the text. Please retake it from a different angle.",
  "idr.sameSide": "Both photos are of the same side. Please upload the front and the back separately.",
  "idr.expired": "This document has expired. Please use one that is still valid.",
  "idr.notAccepted": "That isn't a document we can accept (we need a national ID card, passport, driving licence or residence permit).",
  "idr.nameMismatch": "The name on the document doesn't match the name on the account. Please check and upload again.",

  // ── 帳號設定 ──
  "nav.settingsAccount": "Account",
  "acct.password": "Change your password",
  "acct.lede": "Changing it signs you out everywhere else. This session stays open.",
  "acct.current": "Current password",
  "acct.new": "New password",
  "acct.minLength": "At least 12 characters",
  "acct.tooShort": "Too short — at least 12 characters",
  "acct.confirm": "Type it again",
  "acct.mismatch": "The two entries don't match",
  "acct.failed": "Couldn't change the password.",
  "acct.network": "Connection failed. Please try again shortly.",
  "acct.done": "Password updated. Every other device has been signed out.",
  "acct.saving": "Saving…",
  "acct.submit": "Update password",
  "acct.note": "We ask for your current password so that someone who finds an open tab can't lock you out of your own account.",
  "acct.lockedOut": "Forgot it and can't get in?",
  "acct.lockedOutBody": "Run this on a machine with the repo checked out. The password is typed into your own terminal — it is never echoed, never stored in shell history, and never passed as a command-line argument.",
  "sf.reveal": "Show the value",
  "sf.hide": "Hide the value",

  // ── 伺服器端的錯誤訊息 ──
  "srv.admin.notFreelancer": "This account isn't a freelancer, so there's no membership to adjust.",
  "srv.admin.alreadyReviewed": "This submission has already been reviewed.",
  "srv.admin.rejectReason": "A rejection needs a reason — the person has to know what to fix.",
  "srv.admin.suspendReason": "A suspension needs a reason.",
  "srv.admin.badCredentials": "Email or password is not correct.",
  "srv.admin.originChanged": "The sign-in origin changed. Please log in again.",
  "srv.admin.badCurrentPassword": "That current password is not correct.",
  "srv.admin.samePassword": "The new password must differ from the current one.",
  "srv.admin.noResendKey": "The Resend API key hasn't been set yet.",
  "srv.admin.noEcpayKeys": "ECPay is not configured. Add the merchant ID, HashKey and HashIV under Payment settings.",
  "srv.admin.templateData": "The email template is missing required data.",
  "srv.admin.emailFailed": "Sending the email failed.",
  "srv.admin.resolutionNote": "Write a note explaining the decision.",
  "nav.reports": "Reports",
  "rep.title": "Reports",
  "rep.lede": "One report can be a misunderstanding. Several from different people is not — the repeat count is shown on every row.",
  "rep.empty": "Nothing here.",
  "rep.needNote": "Write a note before closing this.",
  "rep.failed": "Could not save.",
  "rep.network": "Network error. Try again.",
  "rep.tab.open": "Open",
  "rep.tab.reviewing": "Reviewing",
  "rep.tab.actioned": "Actioned",
  "rep.tab.dismissed": "Dismissed",
  "rep.tab.all": "All",
  "rep.reason.scam": "Scam",
  "rep.reason.offPlatform": "Off-platform deal",
  "rep.reason.impersonation": "Impersonation",
  "rep.reason.harassment": "Harassment",
  "rep.reason.spam": "Spam",
  "rep.reason.fakeWork": "Stolen work",
  "rep.reason.illegal": "Illegal",
  "rep.reason.other": "Other",
  "rep.kind.user": "Person",
  "rep.kind.job": "Job",
  "rep.kind.message": "Message",
  "rep.kind.proposal": "Proposal",
  "rep.repeat": "Reported {n}×",
  "rep.alreadySuspended": "Already suspended",
  "rep.reporter": "From",
  "rep.target": "About",
  "rep.notePlaceholder": "What did you find, and what did you do about it?",
  "rep.action.actioned": "Acted on it",
  "rep.action.dismissed": "Dismiss",
  "rep.action.reviewing": "Still looking",
  "nav.fraud": "Signals",
  "fr.title": "Fraud signals",
  "fr.lede": "Detected by rules, not reported by anyone. Your job here is to judge whether the rule got it right — a wrong flag is worth knowing about.",
  "fr.empty": "Nothing here.",
  "fr.needNote": "Write a note before closing this.",
  "fr.failed": "Could not save.",
  "fr.network": "Network error. Try again.",
  "fr.tab.open": "Open",
  "fr.tab.actioned": "Actioned",
  "fr.tab.dismissed": "False positive",
  "fr.tab.all": "All",
  "fr.kind.job": "Job",
  "fr.kind.proposal": "Proposal",
  "fr.kind.message": "Message",
  "fr.kind.profile": "Profile",
  "fr.author": "Written by",
  "fr.target": "Target",
  "fr.alreadySuspended": "Already suspended",
  "fr.notePlaceholder": "What did you find, and what did you do about it?",
  "fr.action.actioned": "Real — acted on it",
  "fr.action.dismissed": "False positive",
  "fr.whyNote": "Marking a false positive is not wasted effort — that is the only data that tells us a rule is too loose.",
  "fr.signal.advanceFee": "Asks for money upfront",
  "fr.signal.overpayment": "Overpayment refund scam",
  "fr.signal.crypto": "Crypto payment",
  "fr.signal.offPlatform": "Moving off the platform",
  "fr.signal.impersonation": "Impersonating the platform",
  "fr.signal.credentials": "Asks for a code or password",
  "fr.signal.tooGoodToBeTrue": "High pay, no experience",
  "fr.signal.urgency": "Time pressure",
  "fr.excerptWithheld": "Message content is private and is not stored here. Judge by the signals and by how often this account has been flagged.",
  "srv.admin.noPaypalKeys": "PayPal Client ID and Secret haven't been set yet.",
} as const;

export default en;

/** 所有翻譯 key 的聯集型別 —— t() 靠它做編譯期檢查 */
export type TranslationKey = keyof typeof en;
export type Dictionary = Record<TranslationKey, string>;
